export default "Please refer to the contract signed with Exotrail when purchasing the licenses.\n"